import http from '@/axios/http'

const fetch = ({ url = '/get_robots', event_id } = {}) => {
  const params = event_id ? `?event_id=${event_id}` : ''
  return http
    .get(url + params)
    .then(response => response.data)
}

export default fetch
